import { Component } from '@angular/core';

@Component({
  selector: 'app-microsoft-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './microsoft-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class MicrosoftIconComponent {}
